
export type GetMetricsSummary200 = { [key: string]: unknown };
